// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/components/claim-analytics-header/claim-analytics-header.less
// module id = 3880
// module chunks = 0